import isIPad from 'meinian-package/src/common/isIPad'

export const getIpadVh = () => `${isIPad ? `${document.getElementById('root')?.getAttribute('height')}px` : '100vh'}`
